function sliderTextMedia() {
    document.querySelectorAll('.text_media_swiper-js').forEach(function(swiperContainer) {
        new Swiper(swiperContainer, {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 0,
            pagination: {
                el: swiperContainer.parentElement.querySelector('.swiper-pagination'),
                clickable: true,
            },
            navigation: {
                nextEl: swiperContainer.parentElement.querySelector('.swiper-button-next'),
                prevEl: swiperContainer.parentElement.querySelector('.swiper-button-prev'),
            },
        });
    });
}

function sliderTextMediaCards() {
    document.querySelectorAll('.text_media_cards-js').forEach(function(swiperContainer) {
        new Swiper(swiperContainer, {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 0,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            pagination: {
                el: swiperContainer.parentElement.querySelector('.text_media_cards_pagination-js'),
                clickable: true,
            },
        });
    });
}

$(function() {
    sliderTextMedia();
    sliderTextMediaCards();
});
